import { render } from "./PresidentcardTab.vue?vue&type=template&id=3c88bf8b&scoped=true"
import script from "./PresidentcardTab.vue?vue&type=script&lang=js"
export * from "./PresidentcardTab.vue?vue&type=script&lang=js"

import "./PresidentcardTab.vue?vue&type=style&index=0&id=3c88bf8b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c88bf8b"]])

export default __exports__